import { FRONTEND_RELEASE_SHA, RAILS_ENV } from './globals';

import Raven from 'raven-js';

interface ICallbackData {
  message?: string;
  stacktrace?: {
    frames: Array<{
      filename: string;
      function: string;
      in_app: boolean;
    }>;
  };
  exception?: {
    values: Array<{
      type: string;
      value: string;
    }>;
  };
  request: {
    url: string;
    headers: any;
  };
}

export const loadSentry = (url: string) => {
  // don't intstall Raven in server side rendering
  if (url && typeof window !== 'undefined') {
    const ignoreErrors: RegExp[] = [];
    if (navigator.userAgent.match('CriOS')) {
      // Error generated by a bug in auto-fill library from Chrome Mobile on iOS
      // https://github.com/getsentry/sentry/issues/5267
      ignoreErrors.push(/Blocked a frame with origin/);
    }

    Raven.config(url, {
      environment: RAILS_ENV,
      ignoreErrors,
      shouldSendCallback: (data: ICallbackData) => {
        // Google Tag Manager buggy code (not maintained by us)
        if (data.exception && data.exception.values && data.exception.values[0]) {
          const value = data.exception.values[0].value;
          if (value && /_cc11509/.test(value)) {
            return false;
          }
        }
        // Silences sentries for crawlers/prerender.io
        const isPhantomJS = /PhantomJS/.test(window.navigator.userAgent);
        return !isPhantomJS;
      },
    })
      .setRelease(FRONTEND_RELEASE_SHA)
      .install();

    (window as any).onunhandledrejection = (evt: PromiseRejectionEvent) => {
      Raven.captureException(evt.reason);
    };
  }
};
